import { distance3d } from "@project-rouge/rg-three";
import { Vector3 } from "three";
function calculateFireDoorsPositionsForDistance(wallPositions, maxDistance) {
  const positions = [];
  for (let i = 0; i < wallPositions.length - 1; i++) {
    const start = wallPositions[i];
    const end = wallPositions[i + 1];
    const dist = distance3d(start, end);
    if (dist > maxDistance) {
      const requiredSections = Math.ceil(dist / maxDistance);
      const factor = 1 / requiredSections;
      for (let j = 1; j < requiredSections; j++) {
        const pos = new Vector3(...start).lerp(new Vector3(...end), j * factor).toArray();
        positions.push(pos);
      }
    }
  }
  return positions;
}
export {
  calculateFireDoorsPositionsForDistance
};
//# sourceMappingURL=index115.js.map
